import Badge from 'react-bootstrap/Badge'

const BadgeValidacao = ({validacao, confirmado} : {validacao: any, confirmado: boolean}) => {
    return (
        <Badge bg="danger" style={validacao && confirmado ? {display: 'inline'} : {display: 'none'}}>{validacao}</Badge>
    )
}

export default BadgeValidacao;